import { Transaction } from "./Transaction";
import { TransactionType } from "../shared/Consts";

export class CashTransaction extends Transaction {
    override clone(reset?:boolean){
        const ret = new CashTransaction(this.holding, this)
        if (reset) ret.json._id = ""
        return ret
    }
    override get actionName(): string {
        if (this.isDividend) return "Interest";
        else if (this.type==TransactionType.adjust) return "Adjustment"
        else return this.isBuy ? "Deposit" : "Withdraw"
    }
    override addActionClass(klass:string[]){
        switch(this.type){
        case TransactionType.adjust:
        case TransactionType.buy:       klass.push(this.quantity>0?"blue":"red"); break;
        case TransactionType.interest:
        case TransactionType.dividend:  klass.push("green"); break;
        }
    }
}